import { useTimeout } from "react-use"

import EmptyQueueView from "@/components/EmptyQueueView"
import { config } from "@/config"

import { WaitingForTaskView } from "./loading-view"

export function AvailableView() {
  const delay = config.emptyQueueOffset
  const [hasDelayElapsed] = useTimeout(delay)

  if (hasDelayElapsed()) {
    return <EmptyQueueView />
  } else {
    return <WaitingForTaskView />
  }
}
